import React, { useEffect, useState } from 'react';
import apiClient from '../api/client';
export default function EmployeeLeaveHistory({ employeeId }: { employeeId: string }) {
  const [items, setItems] = useState<any[]>([]),
    [balance, setBalance] = useState<any>();
  useEffect(() => {
    void Promise.all([
      apiClient.get('/leaves', { params: { employeeId } }),
      apiClient.get(`/leaves/vacation/${employeeId}`),
    ]).then(([i, b]) => {
      setItems(i.data);
      setBalance(b.data);
    });
  }, [employeeId]);
  return (
    <section className="documents">
      <h3>Licencias, vacaciones y ausencias</h3>
      {balance && (
        <p>
          Vacaciones {balance.year}: <strong>{balance.used}</strong> días utilizados ·{' '}
          <strong>{balance.available}</strong> disponibles
        </p>
      )}
      <div className="document-list">
        {items.length ? (
          items.map((x) => (
            <article key={x.id}>
              <div>
                <strong>{x.leaveType.name}</strong>
                <small>
                  {new Date(x.startAt).toLocaleDateString('es-AR')} –{' '}
                  {new Date(x.endAt).toLocaleDateString('es-AR')} · {x.status}
                </small>
              </div>
            </article>
          ))
        ) : (
          <p>Sin antecedentes registrados.</p>
        )}
      </div>
    </section>
  );
}
